<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import HotelMap from '~src/components/search/offers/hotelMap.src'
    import {MarkerClusterer} from '@googlemaps/markerclusterer'
    import {searchRequest} from '~src/utils/hotels/hotels-blank-states.src'

    @Component({mixins: [HotelMap]})
    export class HotelMapModified extends Vue {
        hideExpandButton = true

        setMarkers(offers, fitBounds = true) {
            this.markers.forEach(marker => toRaw(marker).setMap(null))
            if (this.markerCluster) {
                toRaw(this.markerCluster).clearMarkers()
            }
            this.markers = []
            if (!offers.length) return
            offers.forEach(offer => {
                this.addMarker(offer)
            })
            this.bounds = new this.google.maps.LatLngBounds()
            this.markers.forEach(marker => this.bounds.extend(marker.getPosition()))
            if (fitBounds) {
                this.setMapPosition()
            }

            this.markerCluster = new MarkerClusterer({
                map: toRaw(this.map),
                markers: toRaw(this.markers),
                renderer: {
                    render: ({count, position}) => {
                        const color = this.$vuetify.theme.themes.light.colors.primary
                        const svg = btoa(`
                            <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                                <ellipse style="stroke: ${color}; fill: rgb(255, 255, 255); stroke-width: 4px;" cx="30" cy="30" rx="28" ry="28"></ellipse>
                                <text style="fill: ${color}; font-family: sans-serif; font-size: 14px; white-space: pre; text-anchor: middle;" x="30" y="35">${count}</text>
                            </svg>
                        `)
                        return new this.google.maps.Marker({
                            position,
                            icon: {
                                url: `data:image/svg+xml;base64,${svg}`,
                                scaledSize: new this.google.maps.Size(45, 45),
                            },
                            label: {
                                text: ' ',
                            },
                            // adjust zIndex to be above other markers
                            zIndex: Number(this.google.maps.Marker.MAX_ZINDEX) + count,
                        })
                    },
                },
            })
        }

        addMarker(offer) {
            let position
            if (offer.lat && offer.lng) {
                position = {
                    lat: offer.lat,
                    lng: offer.lng,
                }
            } else {
                return
            }

            if (this.markers.findIndex(marker => marker.position === position) !== -1) return

            const marker = new this.google.maps.Marker({
                position,
                icon: this.createMarkerIcon(offer),
                data: offer,
            })

            marker.addListener('click', () => {
                const route = hotelsRuntimeStore.hotelPageLink(
                    {name: marker.data.name},
                    {
                        ...searchRequest(),
                        citizenshipId: authStore.defaultCitizenshipId,
                        cityId: marker.data.cityId,
                    }
                )

                route.query.hotelId = marker.data.id

                this.$router.push(route)
            })

            this.markers.push(marker)
            return marker
        }

        setMapPosition() {
            this.map.fitBounds(this.bounds)
            this.mapPositionInit = true
        }

        saveMapPosition() {}
    }

    export default {...toNative(HotelMapModified), ssrRender: HotelMap.ssrRender}
</script>

<style scoped lang="scss">
    @use 'vuetify/settings';
    @use 'sass:map';

    .map {
        position: fixed;

        @media #{map.get(settings.$display-breakpoints, 'xs')} {
            margin-left: -(settings.$container-padding-x);
        }

        > div {
            height: 100%;
        }
    }

    :deep(.custom-label) {
        background-color: rgb(var(--v-theme-primary)) !important;
        border: 3px solid white !important;
        border-radius: 20px;
        padding: 4px !important;
        color: white !important;
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translateX(-25%);
    }
</style>
